import React from 'react'
import css from "./Steps.module.css"
import SININTERMEDIARIOS from '../../../../assets/SIN INTERMEDIARIOS.PNG';
import AgricultorLocal from '../../../../assets/Agricultor local.jpg';
import ComunidadBiocerca from '../../../../assets/Comunidad biocerca.jpg'


const images = [
    {
        image:SININTERMEDIARIOS,
        stepTitle:"Paso 1: Elige lo que tienes cerca",
        stepPoint:"Abres el mapa. Miras a tu alrededor. Y descubres que lo que buscabas siempre ha estado ahí: agricultores reales, alimentos de verdad, a pocos kilómetros de ti.",
    },
     {
        image:AgricultorLocal,
         stepTitle:"Paso 2: Compra directo, sin trampa ni cartón",
        stepPoint:"Olvídate de intermediarios invisibles. Aquí tú llenas tu carrito con productos de uno, dos o diez agricultores si quieres… y haces un único pago.",
    },
     {
        image:ComunidadBiocerca,
         stepTitle:"Paso 3: Recoge, respira, reconecta",
        stepPoint:"Llega el momento mágico: vas tú. Recoges tus alimentos directamente del lugar donde nacieron. Y, si quieres, puedes charlar con quien los cultivó.",
    }
]

const Steps = () => {
  return (
    <>
    <section className={css.stepsBlock}>
        <div className={css.innerContainer}>
                <div className={css.stepsAll}>
                    <div className={css.stepsImages}>
                        {images.map((items,index)=>{
                          return <>
                           <div className={css.pointsCard}>
                             <div className={css.imagesCard}>
                                <img src={items.image} alt='asdf'/>
                                </div>
                                 <div className={css.cardText}>
                                    <h3>{items.stepTitle}</h3>
                                    <p>{items.stepPoint}</p>
                             </div>
                             </div>
                          </>
                                
                            })}
                            </div>
                          
                </div>
                       
                </div>
             
        
     </section>   
    </>
  )
}

export default Steps
